export default "__VITE_ASSET__8e864964__"